<template lang="pug">
transition(name='slideInFromRight' @after-enter="afterEnter" @after-leave="afterLeave")
  .vue-slideout.vld-parent(v-if="visible" :id="id" :style="style")
    Loading(:active="isLoading" :is-full-page="false" color="#65a946")
    slot
      No slot
</template>

<script>
import Vue from "vue";
import { VueSlideoutEvent } from "./vueSlideoutEvent";
import "./scss";

let nextId = 0;

export default {
  name: "VueSlideout",
  props: {
    id: {
      type: String,
      default: function() {
        return "vueSlideout-" + nextId++;
      },
      required: false,
    },
    show: Boolean,
  },
  data() {
    return {
      visible: false,
      hiding: false,
      style: null,
    };
  },
  beforeCreate() {
    document.body.style["overflow-x"] = "hidden";
  },
  created() {
    this.$vueSlideout.$on("show-" + this.id, this.onShow);
    this.$vueSlideout.$on("hide-" + this.id, this.onHide);
    this.$vueSlideout.$on("escape-" + this.id, this.onEscape);

    this.$emit("created", this);
    this.$emit("created" + this.id, this);
    if (this.show) {
      Vue.nextTick(() => this.onShow({ detail: { target: this.id } }));
    }
  },
  destroyed() {
    this.$vueSlideout.$off("show-" + this.id, this.onShow);
    this.$vueSlideout.$off("hide-" + this.id, this.onHide);
    this.$vueSlideout.$off("escape-" + this.id, this.onEscape);

    document.body.style["overflow-x"] = "";
    this.$vueSlideout.remove(this);
  },
  mounted() {
    this.$vueSlideout.mount(this);
    this.$emit("loadingComplete");
  },
  methods: {
    onShow(event) {
      if (!this.visible && event.detail.target === this.id) {
        this.hiding = false;
        const level = this.$vueSlideout.increment();
        const style = { "z-index": 300 + (level - 1) * 10 };
        const parent = this.$vueSlideout.count > 1 && this.$vueSlideout.parent(this);
        if (parent && parent.style) {
          const parentStyle = window.getComputedStyle(parent);
          const parentWidth = parseInt(parentStyle.getPropertyValue("width"));
          style.minWidth = (isNaN(parseInt(parentWidth)) ? parent.clientWidth : parentWidth) + "px";
        }
        this.style = style;
        this.visible = true;
        this.$emit("show", event);
      }
    },
    onEscape(event) {
      if (this.visible && event.detail.target === this.id) {
        this.$emit("escape", event);
      }
    },
    onHide(event) {
      if (this.visible && event.detail.target === this.id) {
        this.hiding = true;
        const hidingEvent = new VueSlideoutEvent("hiding-" + this.id, this.id, this, event);
        this.$vueSlideout.$emit(hidingEvent);
        this.visible = false;
        this.$emit("hide", event);
      }
    },
    afterLeave(element) {
      if (!this.visible) {
        this.hiding = false;
        Vue.nextTick(() => {
          const hiddenEvent = new VueSlideoutEvent("hidden-" + this.id, this.id, this, element);
          this.$vueSlideout.$emit(hiddenEvent);
          this.$emit("hidden", hiddenEvent);
        });
      }
    },
    afterEnter(element) {
      if (this.visible) {
        Vue.nextTick(() => {
          const shownEvent = new VueSlideoutEvent("shown-" + this.id, this.id, this, element);
          this.$vueSlideout.$emit(shownEvent);
          this.$emit("shown", shownEvent);
        });
      }
    },
    getPath(event) {
      //polyfill: https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
      let path = (event.composedPath && event.composedPath()) || event.path,
        target = event.target;

      if (path != null) {
        // Safari doesn't include Window, but it should.
        return path.indexOf(window) < 0 ? path.concat(window) : path;
      }

      if (target === window) {
        return [window];
      }

      function getParents(node, memo) {
        memo = memo || [];
        const parentNode = node.parentNode;

        return parentNode ? getParents(parentNode, memo.concat(parentNode)) : memo;
      }

      return [target].concat(getParents(target), window);
    },
  },
};
</script>
